// ==========================
// Background Data To Populate Dynamic Dropdowns
// ==========================

// Retrieve embedded product data from a JSON script tag
function getProductData(templateId) {
    const json = $(`#products-${templateId}`).html();
    return JSON.parse(json);
}

// Populate dropdowns (Product > Fit > Size) for a line item row
function populateDropdowns(row, products) {
    const productSelect = row.find('.productSelect');
    const fitSelect = row.find('.fitSelect');
    const sizeSelect = row.find('.sizeSelect');

    // Fill product dropdown
    productSelect.empty().append(`<option value="">Select Product</option>`);
    products.forEach((product, index) => {
        productSelect.append(`<option value="${index}">${product.title}</option>`);
    });

    // Update Fit/Size on product change
    productSelect.change(function () {
        const selectedProduct = products[this.value];
        const fits = [...new Set(selectedProduct.variants.map(v => v.option1))];
        const sizes = [...new Set(selectedProduct.variants.map(v => v.option2))];

        fitSelect.empty().append(`<option value="">Select Fit/Style</option>`);
        fits.forEach(f => fitSelect.append(`<option value="${f}">${f}</option>`));

        sizeSelect.empty().append(`<option value="">Select Size</option>`);
        sizes.forEach(s => sizeSelect.append(`<option value="${s}">${s}</option>`));
    });
}

// ==========================
// New Line Item Quantity Selector
// ==========================

$(document).on('input', '.quantityInput', function () {
    const $row = $(this).closest('.itemRow');
    const quantity = parseInt($(this).val(), 10);
    const name = $row.find('input[name="player"]').val().trim();
    const number = $row.find('input[name="number"]').val().trim();
    const name2 = $row.find('input[name="player2"]').val().trim();

    if ((name || number || name2) && quantity > 1) {
        $(this).val(1);
        alert("Quantity can only be greater than 1 if name and number are both empty. Please duplicate [+] if customizing.");
    }
});

// Also listen to input on the name/number fields
$(document).on('input', 'input[name="player"], input[name="number"], input[name="player2"]', function () {
    const $row = $(this).closest('.itemRow');
    const quantity = parseInt($row.find('.quantityInput').val(), 10);
    const name = $row.find('input[name="player"]').val().trim();
    const number = $row.find('input[name="number"]').val().trim();
    const name2 = $row.find('input[name="player2"]').val().trim();

    if ((name || number || name2) && quantity > 1) {
        $row.find('.quantityInput').val(1);
        alert("Quantity can only be greater than 1 if name and number are both empty. Please duplicate [+] if customizing.");
    }
});

// ==========================
// DYNAMIC ROW ADDITION
// ==========================

$("[id^=newLine]").click(function () {
    const btnId = $(this).attr("id");
    const rowNum = btnId.replace("newLine", "");
    const templateId = `#lineItemRow${rowNum}`;

    const newRow = $(templateId).clone().removeAttr("id").addClass("itemRow").show();
    newRow.data("templateType", `lineItemRow${rowNum}`);

    const productDataRaw = $(`#products-lineItemRow${rowNum}`).text();
    const productData = JSON.parse(productDataRaw);

    const productSelect = newRow.find(".productSelect");
    const fitSelect = newRow.find(".fitSelect");
    const sizeSelect = newRow.find(".sizeSelect");

    // Clear and populate product dropdown
    productSelect.empty().append(`<option value="">Select Product</option>`);
    productData.forEach(product => {
        productSelect.append(`<option value="${product.handle}">${product.title}</option>`);
    });

    // On change, populate fit and size
    productSelect.off('change').on('change', function () {
        const selectedHandle = $(this).val();
        const selectedProduct = productData.find(p => p.handle === selectedHandle);
        const variants = selectedProduct ? selectedProduct.variants : [];

        const fits = [...new Set(variants.map(v => v.option1))];
        const sizes = [...new Set(variants.map(v => v.option2))];

        fitSelect.empty().append('<option value="">Select Fit/Style</option>');
        fits.forEach(fit => fitSelect.append(`<option value="${fit}">${fit}</option>`));

        sizeSelect.empty().append('<option value="">Select Size</option>');
        sizes.forEach(size => sizeSelect.append(`<option value="${size}">${size}</option>`));
    });

    $("#itemsContainer").append(newRow);
});

// ==========================
// Duplicate Existing Row
// ==========================

$(document).on("click", ".duplicateBtn", function () {
    const $originalRow = $(this).closest(".itemRow");
    if (!$originalRow.length) return;

    // template type data for share link & export
    const templateType = $originalRow.attr("data-template-type") || $originalRow.data("templateType");

    // Clone the row including current input/select values
    const $newRow = $originalRow.clone().removeAttr("id").addClass("itemRow").show();

    if (templateType) {
        $newRow.attr("data-template-type", templateType);
    }

    // Maintain template reference
    $newRow.attr("data-template-id", $originalRow.attr("data-template-id"));

    // Copy all selects' values
    $originalRow.find("select").each(function (index) {
        const selectedVal = $(this).val();
        const $originalSelect = $(this);
        const $newSelect = $newRow.find("select").eq(index);

        // Rebuild all options
        $newSelect.empty();
        $originalSelect.find("option").each(function () {
            const $option = $(this).clone();
            $newSelect.append($option);
        });

        // Set selected value
        $newSelect.val(selectedVal);

        // Disable product select only
        if ($originalSelect.hasClass("productSelect")) {
            $newSelect.prop("disabled", true);
        }
    });

    // Insert after original row
    $originalRow.after($newRow);
});


// ==========================
// SERIALIZATION
// ==========================

function serializeForm() {
    const repeatOrder = $("input[name='repeatOrder']:checked").val() || "";
    const billingMatchesShipping = $("input[name='billingMatchesShipping']:checked").val() || "";
    const fulfillment = $("input[name='fulfillment']:checked").val() || "";
    const deliveryDeadline = $("input[name='deliveryDeadline']:checked").val() || "";

    // Team Info object
    const teamInfo = {
        teamName: $("#teamName").val(),
        contactName: $("#contactName").val(),
        contactEmail: $("#contactEmail").val(),
        contactPhone: $("#contactPhone").val(),
        dueDate: $("#dueDate").val(),
        repeatInfo: $("#repeatInfo").val(),
        deadlineInfo: $("#deadlineInfo").val(),
        shippingName: $("#shippingName").val(),
        shippingAddress: $("#shippingAddress").val(),
        shippingAddress2: $("#shippingAddress2").val(),
        shippingCity: $("#shippingCity").val(),
        shippingProvince: $("#shippingProvince").val(),
        shippingPostal: $("#shippingPostal").val(),
        shippingCountry: $("#shippingCountry").val(),
        shippingPhone: $("#shippingPhone").val(),
        shippingEmail: $("#shippingEmail").val(),
        shippingNotes: $("#shippingNotes").val(),
        billingName: $("#billingName").val(),
        billingAddress: $("#billingAddress").val(),
        billingAddress2: $("#billingAddress2").val(),
        billingCity: $("#billingCity").val(),
        billingProvince: $("#billingProvince").val(),
        billingPostal: $("#billingPostal").val(),
        billingCountry: $("#billingCountry").val(),
        billingPhone: $("#billingPhone").val(),
        billingEmail: $("#billingEmail").val()
    };

    // Line items
    const lineItems = [];
    $("#itemsContainer .itemRow").each(function () {
        const row = {
            product: $(this).find(".productSelect").val(),
            colour: $(this).find("input[name='colour']").val(),
            fit: $(this).find(".fitSelect").val(),
            size: $(this).find(".sizeSelect").val(),
            player: $(this).find("input[name='player']").val(),
            number: $(this).find("input[name='number']").val(),
            player2: $(this).find("input[name='player2']").val(),
            special: $(this).find("input[name='special']").val(),
            quantity: parseInt($(this).find('input[name="quantity"]').val(), 10) || 1,
            templateType: $(this).data("templateType")
        };
        lineItems.push(row);
    });

    return { teamInfo, lineItems, repeatOrder, deliveryDeadline, billingMatchesShipping, fulfillment };
}

// ==========================
// RESTORATION FROM LINK
// ==========================

function restoreForm(data) {
    if (!data) return;

    // Restore team info fields
    if (data.teamInfo) {
        Object.entries(data.teamInfo).forEach(([key, value]) => {
            $(`#${key}`).val(value || "");
        });
    }

    // Restore radio selections
    if (data.repeatOrder) {
        $(`input[name='repeatOrder'][value='${data.repeatOrder}']`).prop('checked', true);
    }
    if (data.deliveryDeadline) {
        $(`input[name='deliveryDeadline'][value='${data.deliveryDeadline}']`).prop('checked', true);
    }

    if (data.billingMatchesShipping) {
        $(`input[name='billingMatchesShipping'][value='${data.billingMatchesShipping}']`).prop('checked', true);
    }

    if (data.fulfillment) {
        $(`input[name='fulfillment'][value='${data.fulfillment}']`).prop('checked', true);
    }

    // Rebuild line item rows
    if (Array.isArray(data.lineItems)) {
        $("#itemsContainer").empty();

        data.lineItems.forEach(item => {
            const templateId = `#${item.templateType}`;
            const productData = getProductData(item.templateType);
            const newRow = $(templateId).clone().removeAttr("id").addClass("itemRow").show();

            newRow.data("templateType", item.templateType);

            const productSelect = newRow.find(".productSelect");
            const fitSelect = newRow.find(".fitSelect");
            const sizeSelect = newRow.find(".sizeSelect");

            // Populate product dropdown
            productData.forEach(product => {
                productSelect.append(`<option value="${product.handle}">${product.title}</option>`);
            });
            productSelect.val(item.product).trigger("change");

            // Populate fit/size based on selected product
            const selected = productData.find(p => p.handle === item.product);
            const variants = selected ? selected.variants : [];
            const fits = [...new Set(variants.map(v => v.option1))];
            const sizes = [...new Set(variants.map(v => v.option2))];

            fits.forEach(f => fitSelect.append(`<option value="${f}">${f}</option>`));
            sizes.forEach(s => sizeSelect.append(`<option value="${s}">${s}</option>`));

            fitSelect.val(item.fit);
            sizeSelect.val(item.size);

            newRow.find("input[name='colour']").val(item.colour);
            newRow.find("input[name='player']").val(item.player);
            newRow.find("input[name='number']").val(item.number);
            newRow.find("input[name='player2']").val(item.player2);
            newRow.find("input[name='special']").val(item.special);
            newRow.find("input[name='quantity']").val(item.quantity);

            $("#itemsContainer").append(newRow);
        });
    }
}

// ==========================
// SHARE BUTTON HANDLER
// ==========================

$("#shareButton").click(function () {
    const form = document.querySelector('#orderForm');
    if (!form.checkValidity()) {
        document.documentElement.style.scrollBehavior = 'auto';
        form.reportValidity();
        document.documentElement.style.scrollBehavior = '';
        return;
    }

    const data = serializeForm();
    const compressed = LZString.compressToEncodedURIComponent(JSON.stringify(data));
    const baseUrl = window.location.href.split("?")[0];
    const shareUrl = `${baseUrl}?data=${compressed}`;

    const teamName = $("#teamName").val().trim() || "Link";
    $("#linkOutput").html(`<a href="${shareUrl}" target="_blank">${teamName}'s Form</a>`);

    navigator.clipboard.writeText(shareUrl).then(() => {
        alert('Share link copied to clipboard!');
    });
});

// ==========================
// DELETE ITEM HANDLER
// ==========================

$(document).on("click", ".removeBtn", function () {
    $(this).closest(".itemRow").remove();
});

// ==========================
// INIT ON LOAD
// ==========================

$(document).ready(function () {
    const urlParams = new URLSearchParams(window.location.search);
    const compressedData = urlParams.get('data');

    if (compressedData) {
        try {
            const decompressed = LZString.decompressFromEncodedURIComponent(compressedData);
            const data = JSON.parse(decompressed);
            restoreForm(data);
        } catch (e) {
            console.error("Failed to decompress link data:", e);
            alert("The shared form link appears to be invalid.");
        }
    }
});

// Export to CSV

document.getElementById("exportFormCSV").addEventListener("click", () => {
    const exportForm = document.querySelector('#orderForm');

    // Check main form validity
    if (!exportForm.checkValidity()) {
        exportForm.reportValidity();
        return;
    }

    let isValid = true;

    $("#itemsContainer .itemRow").each(function () {
        const $row = $(this);

        // Validate product
        const $product = $row.find(".productSelect");
        if (!$product.val()) {
            $product.addClass("fieldError");
            isValid = false;
        }

        // Validate fit
        const $fit = $row.find(".fitSelect");
        if (!$fit.val()) {
            $fit.addClass("fieldError");
            isValid = false;
        }

        // Validate size — only if it exists
        const $size = $row.find(".sizeSelect");
        if ($size.length && !$size.val()) {
            $size.addClass("fieldError");
            isValid = false;
        }
    });

    // If invalid, stop CSV export
    if (!isValid) return;

    $(document).on("change", ".productSelect, .fitSelect, .sizeSelect", function () {
        if ($(this).val()) {
            $(this).removeClass("fieldError");
        }
    });

    // Proceed with serialization/export
    const formData = serializeForm();

    // === TEAM INFO CSV (Two-Column Format) ===
    // NOTE: TemplateType intentionally omitted
    const { TemplateType, ...teamInfoFiltered } = formData.teamInfo;

    const teamInfoExtended = {
        repeatOrder: formData.repeatOrder || "",
        deliveryDeadline: formData.deliveryDeadline || "",
        billingMatchesShipping: formData.billingMatchesShipping || "",
        fulfillment: formData.fulfillment || "",
        ...teamInfoFiltered
    };

    const teamCsvRows = [["Form Field", "Team Info"]];// Section label

    ["repeatOrder", "repeatInfo"].forEach(key => {
        teamCsvRows.push([
            `"${key}"`,
            `"${(teamInfoExtended[key] || "").replace(/"/g, '""')}"`
        ]);
    });
    teamCsvRows.push(["", ""]);

    [
        "deliveryDeadline",
        "dueDate",
        "deadlineInfo"
    ].forEach(key => {
        teamCsvRows.push([
            `"${key}"`,
            `"${(teamInfoExtended[key] || "").replace(/"/g, '""')}"`
        ]);
    });
    teamCsvRows.push(["", ""]);
    [
        "teamName",
        "contactName",
        "contactEmail",
        "contactPhone"
    ].forEach(key => {
        teamCsvRows.push([
            `"${key}"`,
            `"${(teamInfoExtended[key] || "").replace(/"/g, '""')}"`
        ]);
    });
    teamCsvRows.push(["", ""]);
    [
        "fulfillment",
        "shippingNotes",
        "shippingName",
        "shippingAddress",
        "shippingAddress2",
        "shippingCity",
        "shippingProvince",
        "shippingPostal",
        "shippingCountry",
        "shippingPhone",
        "shippingEmail"
    ].forEach(key => {
        teamCsvRows.push([
            `"${key}"`,
            `"${(teamInfoExtended[key] || "").replace(/"/g, '""')}"`
        ]);
    });
    teamCsvRows.push(["", ""]);
    [
        "billingMatchesShipping",
        "billingName",
        "billingAddress",
        "billingAddress2",
        "billingCity",
        "billingProvince",
        "billingPostal",
        "billingCountry",
        "billingPhone",
        "billingEmail"
    ].forEach(key => {
        teamCsvRows.push([
            `"${key}"`,
            `"${(teamInfoExtended[key] || "").replace(/"/g, '""')}"`
        ]);
    });
    teamCsvRows.push(["", ""]);

    const teamCsv = teamCsvRows.map(row => row.join(",")).join("\n");

    // === LINE ITEMS CSV (Tabular Format) ===

       const formatPlayerNumber = val => {
        if (val == null) return "";

        const str = String(val).trim();

        const hasLeadingZeros = /^0\d+$/.test(str);

        if (hasLeadingZeros) {
            return `="${str.replace(/"/g, '""')}"`;
        }

        return `"${str.replace(/"/g, '""')}"`;
    };

    const lineItemHeaders = ["Quantity", "Product", "Colour", "Fit", "Size", "Number", "Name", "Name/Title", "Special"];

    const sortedLineItems = formData.lineItems.sort((a, b) => {
        const compare = (x, y) => (x || "").localeCompare(y || "", undefined, { sensitivity: 'base' });

        const prodCompare = compare(a.product, b.product);
        if (prodCompare !== 0) return prodCompare;

        const colourCompare = compare(a.colour, b.colour);
        if (colourCompare !== 0) return colourCompare;

        const fitCompare = compare(a.fit, b.fit);
        if (fitCompare !== 0) return fitCompare;

        const sizeCompare = compare(b.size, a.size); // Reverse
        if (sizeCompare !== 0) return sizeCompare;

        const numA = parseInt(a.number, 10);
        const numB = parseInt(b.number, 10);
        return (isNaN(numA) ? Infinity : numA) - (isNaN(numB) ? Infinity : numB);
    });

        const lineItemRows = sortedLineItems.map(item => [
        `"${String(item.quantity || 1).replace(/"/g, '""')}"`,
        `"${(item.product || "").replace(/"/g, '""')}"`,
        `"${(item.colour || "").replace(/"/g, '""')}"`,
        `"${(item.fit || "").replace(/"/g, '""')}"`,
        `"${(item.size || "").replace(/"/g, '""')}"`,
        formatPlayerNumber(item.number),
        `"${(item.player || "").replace(/"/g, '""')}"`,
        `"${(item.player2 || "").replace(/"/g, '""')}"`,
        `"${(item.special || "").replace(/"/g, '""')}"`
    ].join(","));

    const lineItemsCsv = [
        "Line Items and Customization",
        lineItemHeaders.join(","),
        ...lineItemRows
    ].join("\n");


    // === Size Matrix ===

    // Define all valid sizes in order
    const allSizes = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL", "XXXXL"];

    // Map various size terms to standardized labels
    const sizeMap = {
        // XX-Small
        "XX-SMALL": "XXS",
        "2XS": "XXS",
        "2X-SMALL": "XXS",

        // X-Small
        "X-SMALL": "XS",
        "XS": "XS",

        // Small
        "SMALL": "S",
        "S": "S",

        // Medium
        "MEDIUM": "M",
        "M": "M",

        // Large
        "LARGE": "L",
        "L": "L",

        // X-Large
        "X-LARGE": "XL",
        "XL": "XL",

        // XX-Large
        "XX-LARGE": "XXL",
        "2X-LARGE": "XXL",
        "2XL": "XXL",

        // XXX-Large
        "XXX-LARGE": "XXXL",
        "3X-LARGE": "XXXL",
        "3XL": "XXXL",

        // XXXX-Large
        "XXXX-LARGE": "XXXXL",
        "4X-LARGE": "XXXXL",
        "4XL": "XXXXL"
    };

    // Matrix of counts by Product + Colour + Fit + Size
    const matrixMap = {};

    // Loop through sorted line items
    sortedLineItems.forEach(item => {
        const product = (item.product || "").trim();
        const colour = (item.colour || "").trim();
        const fit = (item.fit || "").trim();

        const rawSize = (item.size || "").trim().toUpperCase();
        const normalizedSize = sizeMap[rawSize] || rawSize;
        const quantity = parseInt(item.quantity, 10) || 0;

        const groupKey = `${product}||${colour}||${fit}`;

        // Initialize the matrix row
        if (!matrixMap[groupKey]) {
            matrixMap[groupKey] = {
                product,
                colour,
                fit,
                sizes: Object.fromEntries(allSizes.map(sz => [sz, 0])),
                extraQty: 0
            };
        }

        if (allSizes.includes(normalizedSize)) {
            matrixMap[groupKey].sizes[normalizedSize] += quantity;
        } else {
            matrixMap[groupKey].extraQty += quantity;
        }
    });

    // Matrix header row
    const matrixHeaders = ["Total", "Product", "Colour", "Fit", ...allSizes];

    // Matrix rows of data
    const matrixRows = Object.values(matrixMap).map(group => {
        const sizeCounts = allSizes.map(sz => group.sizes[sz]);
        const hasSizes = group.hasRecognizedSize;
        const total = sizeCounts.reduce((sum, val) => sum + val, 0) + group.extraQty;

        return [
            total ? `"${total}"` : "",
            `"${group.product.replace(/"/g, '""')}"`,
            `"${group.colour.replace(/"/g, '""')}"`,
            `"${group.fit.replace(/"/g, '""')}"`,
            ...sizeCounts.map(val => `"${val}"`)
        ].join(",");
    });

    // Final CSV string for matrix
    const matrixCsv = [
        "Size Matrix Product/Colour/Fit",
        matrixHeaders.join(","),
        ...matrixRows,
        "" // spacer row
    ].join("\n");



    // === COMBINE AND DOWNLOAD CSV ===
    const fullCsv = [teamCsv, "", lineItemsCsv, "", matrixCsv].join("\n");
    const bom = "\uFEFF"; // UTF-8 BOM
    const csvContentWithBom = bom + fullCsv;
    const blob = new Blob([csvContentWithBom], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;

    const teamName = (formData.teamInfo.teamName || "form").trim().replace(/[^a-z0-9_\-]+/gi, "_");
    const today = new Date().toISOString().split("T")[0]; // e.g., "2025-05-01"
    a.download = `${teamName}_${today}_submission.csv`;

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
});


// ==========================
// Unsaved changes alert
// ==========================

window.addEventListener('beforeunload', (event) => {
    const message = "Changes will be lost if you leave this page. Continue?";
    event.returnValue = message;
    return message;
});